import React, { useState, useContext, useEffect } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import classes from "./ProfileComponents.module.scss";
import Button from "../UI/Button";
import { OrgIdContext } from "../../store/orgId_context";
import MyProfile from "../../pages/MyProfile";
import ClientServices from "../servicesComponents/ClientServices";
import LoadingDots from "../UI/LoadingDots";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ClientModal = ({
  closeClientModeHandler,
  orgName,
  isLoaded,
  error,
  connKey,
  removeConnKey,
}) => {
  const [chosenTab, setChosenTab] = useState("editProfile");
  const [profileData, setProfileData] = useState(null);
  const { mainOrgId, mainOrgUsername } = useContext(OrgIdContext);

  const changeTabHandler = (newTab) => {
    setChosenTab(newTab);
  };

  const backToMainOrgHandler = () => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Auth.ChangeOrganization",
          params: {
            orgid: `${mainOrgId}`,
          },
          id: 28,
        },
        {
          withCredentials: true,
        }
      )
      .then(() => {
        removeConnKey();
        closeClientModeHandler();
      });
  };

  useEffect(() => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Auth.GetSessionInfo",
          params: {
            includeExtendedInfo: true,
          },
          id: 38,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result) {
          setProfileData(res.data.result);
          // console.log(res.data.result);
        }
      });
  }, []);

  return (
    <>
      <div className={`${classes["client-container"]} d-flex`}>
        <div className="d-flex justify-content-between align-items-center">
          <Button className="px-5 py-2" onClick={backToMainOrgHandler}>
            Back to my organization
          </Button>
          <p className={`m-0 py-2 ${classes["blue-text"]}`}>
            <span className={classes["orange-span"]}>{mainOrgUsername}</span> in{" "}
            <span className={classes["orange-span"]}>{orgName}</span>
          </p>
        </div>
        {!isLoaded && (
          <LoadingDots
            className="w-100 d-flex align-items-center justify-content-center"
            style={{ flex: 1 }}
          />
        )}
        {isLoaded && error && (
          <div
            className="w-100 d-flex align-items-center justify-content-center"
            style={{ flex: 1, fontSize: "1.2rem" }}
          >
            Invalid client
          </div>
        )}
        {isLoaded && !error && (
          <div className="w-100 d-flex flex-column" style={{ flex: 1 }}>
            <div
              className="d-flex gap-2 mt-3"
              style={{ borderBottom: "1px solid #005683" }}
            >
              <button
                onClick={() => changeTabHandler("editProfile")}
                className={`${classes["client-tab-btn"]} ${
                  chosenTab === "editProfile" && classes["active-tab-btn"]
                } px-3`}
              >
                Edit profile
              </button>
              <button
                onClick={() => changeTabHandler("editInvoices")}
                className={`${classes["client-tab-btn"]} ${
                  chosenTab === "editInvoices" && classes["active-tab-btn"]
                } px-3`}
              >
                Edit invoices
              </button>
              <button
                onClick={() => changeTabHandler("editServices")}
                className={`${classes["client-tab-btn"]} ${
                  chosenTab === "editServices" && classes["active-tab-btn"]
                } px-3`}
              >
                Edit service credentials
              </button>
            </div>
            {chosenTab === "editProfile" && (
              <div>
                <MyProfile companyData={profileData} />
              </div>
            )}
            {chosenTab === "editInvoices" && (
              <iframe
                src="@invt"
                frameBorder="0"
                title="edit-invoices-layout"
                className="w-100"
                style={{ flex: 1 }}
              ></iframe>
            )}
            {chosenTab === "editServices" && (
              <ClientServices connKey={connKey} />
            )}
          </div>
        )}
      </div>
      {createPortal(<div className={classes.clientBg}></div>, document.body)}
    </>
  );
};

export default ClientModal;
